import { useState, useEffect } from 'react';
import i18n from 'i18n-js';
import { withNavBar } from '../../shared/NavBar/NavBar';
import sharedHistory from '../../../shared/History';
import { RouteNames } from '../../../shared/enums/RouteNames';
import Localization from '../../../shared/Localization';
import { Auth } from 'aws-amplify';
import { ThunkDispatch } from 'redux-thunk';
import { ReduxStore } from '../../../store/reducers';
import { SetUserObject } from '../../../store/actions/user/UserActions';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';

interface IPreferencesProps {
  setUserObject: (user: ICognitoUser) => {};
  userObject: ICognitoUser;
}

function Preferences(props: IPreferencesProps) {
  const history = useHistory();
  //Pull from the redux store in the new ticket
  const [name, setName] = useState('');
  const [local, setLocal] = useState<typeof i18n | null>(null);
  useEffect(() => {
    const fetchData = async () => {
      const newLocal = await Localization('en');
      setLocal(newLocal);
    };

    fetchData();
  }, []);

  const handleSkip = () => sharedHistory.push(RouteNames.Observations);

  const handleSave = async () => {
    await Auth.updateUserAttributes(props.userObject, { 'custom:preferences-saved': "true" });
    const newUser = await Auth.currentAuthenticatedUser();
    props.setUserObject(newUser);
    history.push(RouteNames.Home);
  }

  if (!local) return <></>;

  const pageText: string[] = local.t('userPreferences.text') as any;
  const preOptions: string[] = local.t('userPreferences.options') as any;

  const optionsData = [
    { key: preOptions[0], example: 'Northern Cardinal, Purple Finch', enabled: true },
    { key: preOptions[1], example: 'Cardinalis cardinalis, Haemorhous purpureus', enabled: false },
    { key: preOptions[2], example: 'Northern Cardinal - Cardinalis cardinalis', enabled: false },
  ];
  return (
    <div>
      <h4>
        {local.t('userPreferences.title')}
        {name && ` ${name}`}!
      </h4>
      <div className='row'>
        <div className='col s7'>
          <p> {pageText[0]}</p>
          <p> {pageText[1]}</p>
        </div>
        <div className='col s5'>
          <button className='btn btn-tertiary' onClick={handleSkip}>
            {local.t('userPreferences.skipButtonText')}
          </button>
          <button className='btn btn-primary' onClick={handleSave}> {local.t('userPreferences.savePreferencesButtonText')}</button>
        </div>
      </div>
      <div className='row'>
        <div className='col s4'>
          <label className='label'>{local.t('userPreferences.speciesNameLabel')}</label>
          <div>
            {optionsData.map((option) => {
              return (
                <div className='mt-1' key={option.key}>
                  <input type='radio' name='name-display' checked={option.key === preOptions[0]} value={option.key} disabled={!option.enabled} />
                  <label className='radio-button-label' htmlFor='opt1'>
                    {option.key}
                    <br />
                    <div className='radio-button-text'>{option.example}</div>
                  </label>
                </div>
              );
            })}
          </div>
        </div>
        <div className='col s3'>
          <label className='label'>{local.t('userPreferences.commonNameLanguageLabel')}</label>
          <select disabled>
            <option>{local.t('userPreferences.commonNameLanguageEnglishOption')}</option>
          </select>
        </div>
      </div>
    </div>
  );
}

const dispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => ({
  setUserObject: (userObject: ICognitoUser) => dispatch(SetUserObject(userObject))
})

const stateToProps = (state: ReduxStore) => {
  return { userObject: state.User.UserObject }
}

export default withNavBar(connect(stateToProps, dispatchToProps)(Preferences));
